<template>
  <div class="mypage-about-using-pane">
    <mypage-about-using-section
      :title="$tc('MypagePage.MypageAboutUsingPage.title')"
      :aboutUsingListItems="aboutUsingListItems"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import I18n from '@/locales/I18n'
import MypageAboutUsingSection from '@/components/MypageAboutUsingPage/MypageAboutUsingPane/MypageAboutUsingSection.vue'
import Const from '@/util/Const'

interface AboutUsingListData {
  name: string
  link: string
  text: string
}

/**
 * マイページ: ご利用について コンテンツペイン
 */
export default defineComponent({
  name: 'MypageAboutUsingPane',
  components: {
    MypageAboutUsingSection,
  },
  setup() {
    // ご利用について データリスト
    const aboutUsingListItems = [
      {
        name: I18n.tc('MypagePage.MypageAboutUsingPage.privacyPolicy'),
        text: '',
        link: Const.EXTERNAL_LINKS.PRIVACY_POLICY,
      },
      {
        name: I18n.tc('MypagePage.MypageAboutUsingPage.tradingRule'),
        text: '',
        link: Const.EXTERNAL_LINKS.TRADING_RULE,
      },
      {
        name: I18n.tc('MypagePage.MypageAboutUsingPage.terms'),
        text: '',
        link: Const.EXTERNAL_LINKS.TERMS,
      },
    ] as Array<AboutUsingListData>

    return {
      aboutUsingListItems,
    }
  },
})
</script>

<style lang="scss" scoped>
.mypage-about-using-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  padding-top: 24px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
